export default function (value) {
  return JSON.stringify(value).replace(/["'{}]/g, '');
}
